import { isEqual, toPairs, differenceWith, fromPairs } from 'lodash';

export function getChangedValues(obj1, obj2) {
    return fromPairs(differenceWith(toPairs(obj2), toPairs(obj1), isEqual))
}

export function checkForChanges(fields, changes) {
    const changeCollector = []
    fields.forEach(field => {
        if(!changes.includes(field)) changeCollector.push(field)
    })
    return changeCollector
}